package gr.tech.GRAttestation.infrastructure.session

import androidx.compose.runtime.mutableStateOf
import gr.tech.GRAttestation.infrastructure.api.checkStoreUserJWT
import gr.tech.GRAttestation.models.storeusers.StoreUsersDTO

object StoreUserSession {
    var info = mutableStateOf<StoreUsersDTO?>(null)
    val checked = mutableStateOf(false)

    fun getStoreName(): String {
        return info.value?.storeName ?: ""
    }

    fun getRepresentativeName(): String {
        return info.value?.let { "${it.firstName} ${it.lastName}" } ?: ""
    }

    /* ---------------- */
    
    fun isLoggedIn(): Boolean {
        return checked.value && info.value != null
    }

    suspend fun setLoggedIn(userData: StoreUsersDTO? = null): Boolean {
        val result = checkStoreUserJWT()
        info.value = result.data
        checked.value = true
        return result.success
    }

    fun setLoggedOut() {
        info.value = null
        checked.value = false
    }
}